import { tokens } from "@opendoor/tokens-studio/dist/bricks-next/tokens/Components";
import { getTokenValue } from "@tamagui/core";
import { Box } from "../Box/index.mjs";
import { Button } from "../Button/index.mjs";
import { SimpleCheckbox } from "../inputs/index.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
const {
    dialog: dialogTokens
  } = tokens,
  Container = ({
    children,
    $largerThanSM,
    ...props
  }) => /* @__PURE__ */jsx(Box, {
    marginTop: -1 * getTokenValue(dialogTokens.margin.mobile.bottom),
    $largerThanSM: {
      marginTop: -1 * getTokenValue(dialogTokens.margin.desktop.bottom),
      ...$largerThanSM
    },
    ...props,
    children
  }),
  ButtonContainer = ({
    children,
    buttonPosition
  }) => /* @__PURE__ */jsx(Box, {
    paddingTop: dialogTokens.margin.mobile.top,
    paddingBottom: dialogTokens.margin.mobile.bottom,
    paddingHorizontal: dialogTokens.margin.mobile.leftRight,
    $largerThanSM: {
      paddingTop: dialogTokens.margin.desktop.top,
      paddingBottom: dialogTokens.margin.desktop.bottom,
      paddingHorizontal: dialogTokens.margin.desktop.leftRight,
      flexDirection: buttonPosition === "stacked" ? "column" : "row"
    },
    gap: dialogTokens.padding.actions.default,
    children
  }),
  TransactionalActions = ({
    transactionalButtonProps,
    secondaryButtonProps,
    buttonPosition,
    ...props
  }) => /* @__PURE__ */jsx(Container, {
    ...props,
    children: /* @__PURE__ */jsxs(ButtonContainer, {
      buttonPosition,
      children: [secondaryButtonProps && /* @__PURE__ */jsx(Button, {
        variant: "secondary",
        size: "small",
        $largerThanSM: {
          size: "medium",
          flexGrow: 1
        },
        ...secondaryButtonProps
      }), /* @__PURE__ */jsx(Button, {
        variant: "primary",
        size: "small",
        $largerThanSM: {
          size: "medium",
          flexGrow: 1
        },
        ...transactionalButtonProps
      })]
    })
  }),
  DestructiveActions = ({
    destructiveButtonProps,
    secondaryButtonProps,
    buttonPosition,
    ...props
  }) => /* @__PURE__ */jsx(Container, {
    ...props,
    children: /* @__PURE__ */jsxs(ButtonContainer, {
      buttonPosition,
      children: [/* @__PURE__ */jsx(Button, {
        variant: "secondaryInverse",
        size: "small",
        $largerThanSM: {
          size: "medium",
          flexGrow: 1
        },
        ...destructiveButtonProps
      }), secondaryButtonProps && /* @__PURE__ */jsx(Button, {
        variant: "secondary",
        size: "small",
        $largerThanSM: {
          size: "medium",
          flexGrow: 1
        },
        ...secondaryButtonProps
      })]
    })
  }),
  AcknowledgementActions = ({
    buttonProps,
    checkboxProps,
    children,
    ...props
  }) => /* @__PURE__ */jsxs(Container, {
    ...props,
    children: [checkboxProps && /* @__PURE__ */jsx(Box, {
      paddingTop: dialogTokens.margin.mobile.top,
      paddingHorizontal: dialogTokens.margin.mobile.leftRight,
      $largerThanSM: {
        paddingTop: 0,
        paddingHorizontal: dialogTokens.margin.desktop.leftRight
      },
      children: /* @__PURE__ */jsx(SimpleCheckbox, {
        size: "medium",
        ...checkboxProps
      })
    }), /* @__PURE__ */jsx(ButtonContainer, {
      children: /* @__PURE__ */jsx(Button, {
        variant: "primary",
        size: "small",
        $largerThanSM: {
          size: "medium",
          flexGrow: 1
        },
        ...buttonProps
      })
    })]
  });
export { AcknowledgementActions, DestructiveActions, TransactionalActions };